 /**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2019 ruoyi
 */

import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const all_permission = "";
    const permissions = [...store.getters.permissionMenu];

    // if (value && value instanceof Array && value.length > 0) {
    if (value) {
      const permissionFlag = value
      // console.log(permissions)
      const hasPermissions = permissions.some(permission => {
        // console.log(permission.value, value)
        return permission.value && permission.value === value
      })
      // console.log(hasPermissions)

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/hasPermi.js